import { render } from "./PrivateArea.vue?vue&type=template&id=4fc957a4"
import script from "./PrivateArea.vue?vue&type=script&lang=js"
export * from "./PrivateArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__